import React, {useEffect, useState} from "react";
import {Paper, Typography} from "@material-ui/core";
import Box from "@material-ui/core/Box";
import {useSnackbar} from "notistack";
import moment from "moment";
import {useEstadisticasService} from "../../../../../services/hooks";

const formatPeriodo = dates => dates ?
    `${moment(dates.from).format('DD/MM/YYYY')} - ${moment(dates.to).format('DD/MM/YYYY')}` : '';

export const FidelidadClientesCard = ({settingsState, printRef}) => {
    const [fidelidad, setFidelidad] = useState(null);

    const {enqueueSnackbar} = useSnackbar();
    const EstadisticasService = useEstadisticasService();

    useEffect(() => {
        EstadisticasService.getFidelidadClientes(
            settingsState,
            success => setFidelidad(success.data.result),
            error => enqueueSnackbar(error, {variant: 'error'})
        )
    }, [settingsState]);

    const {anterior = 0, actual = 0, ratio = 0, dates} = fidelidad ? fidelidad : {};

    return (
        <Paper ref={printRef} style={{height: '100%'}}>
            <Box className={'pt-3 pb-3 pl-4 pr-4'}>
                <Typography variant={"body1"} color={"textSecondary"}>Fidelidad de Clientes</Typography>
                <Typography variant={"body2"} color={"textSecondary"}>Compradores período actual respecto al anterior</Typography>
                <Typography variant={"h3"} className={'mt-2 mb-2'}>
                    {`${(ratio * 100).toFixed(0)}%`}
                </Typography>
                <Box display={"flex"}>
                    <Box className={'mr-4'}>
                        <Typography variant={"h6"}>{anterior}</Typography>
                        <Typography variant={"caption"} color={"textSecondary"} component={'div'}>
                            compraron entre
                        </Typography>
                        <Typography variant={"caption"} color={"textSecondary"} component={'div'}>
                            {formatPeriodo(dates && dates.anterior)}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant={"h6"}>{actual}</Typography>
                        <Typography variant={"caption"} color={"textSecondary"} component={'div'}>
                            volvieron a comprar entre
                        </Typography>
                        <Typography variant={"caption"} color={"textSecondary"} component={'div'}>
                            {formatPeriodo(dates && dates.actual)}
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Paper>
    )
}
